import { Box, useMediaQuery } from "@mui/material";
import AtheistSvg from "../assets/backgroundImages/atheistLogo.svg";

const AtheismLogo = () => {
  const isMobile = useMediaQuery("(max-width:520px)");
  const isTablet = useMediaQuery("(max-width:1100px) and (pointer: fine)");
  const isLandscape = useMediaQuery(
    "(pointer: coarse) and (orientation: landscape)"
  );

  let layout = ["80%", "50%"];
  if (isMobile) {
    layout = ["50%", "34%"];
  } else if (isTablet) {
    layout = ["80%", "35%"];
  }

  const size = isLandscape ? "10rem" : "12.5rem";

  return (
    <Box
      sx={{
        height: size,
        width: size,
        position: "absolute",
        left: layout[0],
        top: layout[1],
        transform: "translate(-50%, -50%)",
        pointerEvents: "none",
      }}
    >
      <img alt="Atheism Logo" src={AtheistSvg} />
    </Box>
  );
};

export default AtheismLogo;
